module.exports = __webpack_public_path__ + "img/sell-car1536x864.05cf4b84.png";